module.exports = __webpack_public_path__ + "assets/img/select_products5.861baeff.svg";